<template>
  <v-col cols="auto" md="4" lg="3" xl="3" align-self="stretch" class="flex-grow-1">
    <v-card height="100%"
            class="d-flex flex-column"
            min-width="100%"
            :color="theme.color"
            :elevation="theme.elevation"
            :rounded="theme.rounded"
            :dark="theme.dark"
            :light="!theme.dark"
    >
      <v-img v-if="data.image"
             :src="data.image"
             min-height="200px"
             max-height="200px"
             height="200px"
             :eager="data.noimage"
             :transition="false"
             :lazy-src="data.imageLazy"
      />
      <v-card-title style="word-break: normal;">
        {{ name }}
        <div v-if="data.weight" class="text-caption text-no-wrap pl-1">
          {{ data.weight }}
        </div>
      </v-card-title>
      <v-card-text v-if="description || data.ingredients">
        <div v-if="description && description.html" v-html="description.html" />
        <div v-if="data.ingredients" class="font-italic" v-text="data.ingredients" />
      </v-card-text>
      <v-spacer />
      <div v-if="data.tags && data.tags.length > 0" class="ma-4 text-caption font-italic">
        <div v-for="(tag, index) in data.tags" :key="index" class="pr-3 float-left">
          {{ tag.name }}
        </div>
      </div>
      <v-card-actions class="align-self-end">
        <v-spacer />
        <ProductAction :in-basket="inBasket"
                       :menu="menu"
                       :mode="mode"
                       v-bind="data"
                       @plus="plus"
                       @minus="minus"
        />
      </v-card-actions>
    </v-card>
  </v-col>
</template>

<script>
import ProductMixin from '@/components/templates/ProductMixin';

export default {
  name: 'ProductTile',
  mixins: [ProductMixin]
};
</script>
